/* I like dogs — theme.js
   Cart drawer (Cart AJAX + Section Rendering API), variant picker, home filters. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const cfg = window.ILD || { routes: { cart: "/cart", cartAdd: "/cart/add", cartChange: "/cart/change" }, strings: {} };
  const SECTION = "cart-drawer";

  /* ---------- Toast ---------- */
  let toastTimer;
  function toast(msg) {
    const el = $("#toast");
    if (!el) return;
    el.textContent = msg;
    el.classList.add("on");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove("on"), 2400);
  }

  /* ---------- Drawer ---------- */
  let lastFocus = null;
  const drawer = () => $("#drawer");
  const scrim = () => $("#scrim");

  function openCart() {
    const d = drawer(), s = scrim();
    if (!d || !s) return (location.href = cfg.routes.cart);
    lastFocus = document.activeElement;
    s.hidden = false;
    requestAnimationFrame(() => { s.classList.add("on"); d.classList.add("on"); });
    d.setAttribute("aria-hidden", "false");
    const close = $("[data-cart-close]", d);
    close && close.focus();
  }
  function closeCart() {
    const d = drawer(), s = scrim();
    if (!d || !s) return;
    s.classList.remove("on");
    d.classList.remove("on");
    d.setAttribute("aria-hidden", "true");
    setTimeout(() => { s.hidden = true; }, 250);
    lastFocus && lastFocus.focus && lastFocus.focus();
  }

  /* Swap in freshly rendered drawer markup + header count */
  function applySection(html) {
    if (!html) return;
    const doc = new DOMParser().parseFromString(html, "text/html");
    const fresh = $("#cart-drawer-inner", doc);
    const cur = $("#cart-drawer-inner");
    if (fresh && cur) {
      cur.replaceWith(fresh);
      setCount(Number(fresh.dataset.count || 0));
    }
  }
  function setCount(n) {
    const c = $("#cart-count");
    if (!c) return;
    c.textContent = n;
    c.classList.toggle("on", n > 0);
    const btn = $("#open-cart");
    btn && btn.setAttribute("aria-label", `Open cart, ${n} item${n === 1 ? "" : "s"}`);
  }

  async function refreshCart() {
    const res = await fetch(`${location.pathname}?sections=${SECTION}`);
    const data = await res.json();
    applySection(data[SECTION]);
  }

  async function addToCart(form, button) {
    const fd = new FormData(form);
    fd.append("sections", SECTION);
    fd.append("sections_url", location.pathname);
    const label = button && button.textContent;
    if (button) button.disabled = true;
    const errEl = $("[data-form-error]", form);
    if (errEl) errEl.hidden = true;
    try {
      const res = await fetch(`${cfg.routes.cartAdd}.js`, { method: "POST", body: fd, headers: { Accept: "application/json" } });
      const data = await res.json();
      if (!res.ok || data.status) {
        const msg = data.description || data.message || cfg.strings.error;
        if (errEl) { errEl.textContent = msg; errEl.hidden = false; } else toast(msg);
        return;
      }
      applySection(data.sections && data.sections[SECTION]);
      openCart();
    } catch (e) {
      toast(cfg.strings.error || "Something went wrong.");
    } finally {
      if (button) button.disabled = false;
    }
  }

  async function changeLine(line, quantity) {
    try {
      const res = await fetch(`${cfg.routes.cartChange}.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ line, quantity, sections: SECTION, sections_url: location.pathname }),
      });
      const data = await res.json();
      if (!res.ok || data.status) return toast(data.description || data.message || cfg.strings.error);
      applySection(data.sections && data.sections[SECTION]);
    } catch (e) {
      toast(cfg.strings.error || "Something went wrong.");
    }
  }

  /* ---------- Global click handling ---------- */
  document.addEventListener("click", (e) => {
    const open = e.target.closest("[data-cart-open]");
    if (open && drawer()) {
      if (e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      openCart();
      return;
    }
    if (e.target.closest("[data-cart-close]") || e.target.id === "scrim") return closeCart();

    const q = e.target.closest("[data-line][data-qty]");
    if (q) return changeLine(Number(q.dataset.line), Number(q.dataset.qty));

    const thumb = e.target.closest("[data-thumb]");
    if (thumb) {
      const img = $("[data-main-media] img");
      if (img) { img.src = thumb.dataset.thumb; img.removeAttribute("srcset"); }
      $$("[data-thumb]").forEach((b) => b.classList.toggle("on", b === thumb));
      return;
    }

    const pill = e.target.closest(".filters button[data-filter]");
    if (pill) {
      const f = pill.dataset.filter;
      $$(".filters button[data-filter]").forEach((p) => {
        const on = p === pill;
        p.classList.toggle("is-active", on);
        p.setAttribute("aria-pressed", on);
      });
      $$("[data-filter-grid] .card").forEach((c) => c.classList.toggle("is-hidden", f !== "all" && c.dataset.kind !== f));
    }
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && drawer() && drawer().classList.contains("on")) closeCart();
  });

  /* ---------- Add-to-cart forms (cards + product page) ---------- */
  document.addEventListener("submit", (e) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.action || !form.action.includes(cfg.routes.cartAdd)) return;
    if (!drawer()) return;
    e.preventDefault();
    addToCart(form, $("[data-add]", form));
  });

  /* ---------- Variant picker on the product page ---------- */
  const section = $("[data-product-section]");
  const json = section && $("[data-product-json]", section);
  if (section && json) {
    const product = JSON.parse(json.textContent);
    const money = (cents) =>
      new Intl.NumberFormat(undefined, { style: "currency", currency: cfg.currency || "USD", minimumFractionDigits: cents % 100 ? 2 : 0 }).format(cents / 100);

    const update = () => {
      const chosen = $$(".opt", section).map((fs) => {
        const c = $("input:checked", fs);
        return c ? c.value : null;
      });
      const variant = product.variants.find((v) => v.options.every((o, i) => o === chosen[i]));
      const add = $("[data-pdp-add]", section);
      const priceEl = $("[data-price]", section);
      if (!variant) {
        add.disabled = true;
        add.textContent = "Unavailable";
        return;
      }
      $("[data-variant-id]", section).value = variant.id;
      add.disabled = !variant.available;
      add.textContent = variant.available ? "Add to cart" : "Sold out";
      priceEl.innerHTML =
        (variant.compare_at_price > variant.price ? `<s class="was">${money(variant.compare_at_price)}</s> ` : "") + money(variant.price);
      const url = new URL(location.href);
      url.searchParams.set("variant", variant.id);
      history.replaceState({}, "", url);
      const src = variant.featured_image && variant.featured_image.src;
      const img = $("[data-main-media] img");
      if (src && img) { img.src = src; img.removeAttribute("srcset"); }
    };
    $$(".opt input", section).forEach((i) => i.addEventListener("change", update));
  }

  /* Keep drawer fresh when the page is restored from the back/forward cache */
  window.addEventListener("pageshow", (e) => { if (e.persisted && drawer()) refreshCart().catch(() => {}); });
})();
